import { GridSortModel } from '@mui/x-data-grid-premium'
import { ActiveUser } from '~/components/settings/types'
import { TableColumnOption } from '~/components/shared/Table/TableColumnAutocomplete'
import { DossGridFilterModel } from '~/components/tables/filters'
import { DetailedTable } from '~/components/tables/types'
import { CustomFilterPanel } from './CustomFilterPanel'
import { CustomSortPanel } from './CustomSortPanel'
import { TableMenuOptions, useTableMenuContext } from './TableMenus'

interface FilterOrSortPanelProps {
  columns: TableColumnOption[]
  filterModel: DossGridFilterModel
  onFilterModelChange: (model: DossGridFilterModel) => void
  sortModel: GridSortModel
  onSortModelChange: (model: GridSortModel) => void
  activeUsers?: ActiveUser[]
  tableId: string
  readOnly: boolean
  table: DetailedTable
}

export function CustomFilterOrSortPanel({
  columns,
  filterModel,
  onFilterModelChange,
  sortModel,
  onSortModelChange,
  activeUsers,
  tableId,
  readOnly,
  table,
}: FilterOrSortPanelProps) {
  const { selectedOption, pendingSortField, pendingSortDirection, pendingFilterItem } =
    useTableMenuContext()

  return selectedOption === TableMenuOptions.SORT ? (
    <CustomSortPanel
      columns={columns}
      onSortModelChange={onSortModelChange}
      pendingSortDirection={pendingSortDirection}
      pendingSortField={pendingSortField}
      readOnly={readOnly}
      sortModel={sortModel}
      tableId={tableId}
    />
  ) : (
    <CustomFilterPanel
      activeUsers={activeUsers}
      columns={columns}
      filterModel={filterModel}
      onFilterModelChange={onFilterModelChange}
      pendingFilterItem={pendingFilterItem}
      readOnly={readOnly}
      table={table}
      tableId={tableId}
    />
  )
}
